<div
  class="
    card-container
    d-flex
    fd-col
    text-size-14 text-weight-600
    fx-card-hover
    mt-16
    text-gray
    cursor-pointer
  "
  (click)="openModal()"
>
  <div class="title-card d-flex fd-row mb-16 align-items-center">
    <sit-icon
      [icon]="card?.icon"
      [sizeClass]="'icon-size-22'"
      [alt]="'icono de situaciones'"
    ></sit-icon>
    <div class="title-text d-flex fd-col ml-8">
      <h2
        *ngIf="card?.title"
        class="title-card text-weight-700 m-0 ext-size-16"
      >
        {{ card?.title }}
      </h2>
      <!-- TODO: Don't delete this code. It's necessary for next deployment. SINITT-849 -->
      <!-- <span *ngIf="card?.location" class="text-blue-2">{{
        card?.location
      }}</span> -->
    </div>
  </div>

  <div class="dates d-flex fd-col mb-8">
    <div class="date-time1 d-flex fd-row mb-8">
      <label *ngIf="card?.endDate">Desde:</label>
      <label *ngIf="!card?.endDate">Fecha:</label>
      <span class="time text-red ml-8">{{
        card?.initDate | date: 'HH:mm'
      }}</span>
      <span class="text-blue-2 ml-8">•</span>
      <span class="date text-blue-2 ml-8">{{
        card?.initDate | date: 'dd/MM/yy'
      }}</span>
    </div>
    <div *ngIf="card?.endDate" class="date-time2 d-flex fd-row">
      <label>Hasta:</label>
      <span class="time text-red ml-8">{{
        card?.endDate | date: 'HH:mm'
      }}</span>
      <span class="text-blue-2 ml-8">•</span>
      <span class="date text-blue-2 ml-8">{{
        card?.endDate | date: 'dd/MM/yy'
      }}</span>
    </div>
  </div>

  <div *ngIf="card?.territorial" class="territorial d-flex fd-row mb-8">
    <label>Territorial:</label>
    <span class="ml-8">{{ card?.territorial }}</span>
  </div>

  <span
    *ngIf="card?.description"
    class="description text-justify mb-8 text-weight-500"
    >{{ card?.description }}</span
  >

  <div class="border-b-s-1 border-color-blue"></div>
</div>
